/* Irissale — Shoppable campaign. Initialises every .irs-hot on the page. */
(function () {
  function init(root) {
    if (root.dataset.irsReady) return;
    root.dataset.irsReady = '1';

    var SPOTS = [];
    var holder = root.querySelector('[data-irs-hot-data]');
    try { SPOTS = JSON.parse(holder.textContent) || []; } catch (e) { return; }
    if (!SPOTS.length) return;

    var media = root.querySelector('[data-irs-hot-media]');
    var addUrl = root.dataset.addUrl || '/cart/add';
    var ATC = root.dataset.atcLabel || 'add to cart';
    var OOS = root.dataset.oosLabel || 'out of stock';
    var open = null;

    function closeAll() {
      root.querySelectorAll('.irs-hot__card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      root.querySelectorAll('.irs-hot__dot.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        d.setAttribute('aria-expanded', 'false');
      });
      open = null;
    }

    function place(card, x, y) {
      if (window.matchMedia('(max-width:749px)').matches) return;  // fixed sheet
      var w = media.clientWidth, h = media.clientHeight;
      var cw = 236, gap = 18;
      var left = (x / 100) * w + gap;
      if (left + cw > w - 8) left = (x / 100) * w - cw - gap;
      if (left < 8) left = 8;
      card.style.left = left + 'px';
      var top = (y / 100) * h - 20;
      var ch = card.offsetHeight || 150;
      if (top + ch > h - 8) top = h - ch - 8;
      if (top < 8) top = 8;
      card.style.top = top + 'px';
    }

    SPOTS.forEach(function (s, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'irs-hot__dot';
      dot.style.left = s.x + '%';
      dot.style.top = s.y + '%';
      dot.setAttribute('aria-expanded', 'false');
      dot.setAttribute('aria-label', s.title);
      media.appendChild(dot);

      var card = document.createElement('div');
      card.className = 'irs-hot__card';
      card.setAttribute('role', 'dialog');
      card.setAttribute('aria-label', s.title);

      var vIdx = -1;
      s.variants.forEach(function (v, k) { if (vIdx < 0 && v.available) vIdx = k; });
      if (vIdx < 0) vIdx = 0;

      var form = document.createElement('form');
      form.action = addUrl;
      form.method = 'post';
      form.enctype = 'multipart/form-data';

      var head = document.createElement('div');
      head.className = 'irs-hot__row';
      head.innerHTML = '<p class="irs-hot__title"><a></a><button type="button" class="irs-hot__close" aria-label="Close">✕</button></p>';
      head.querySelector('a').textContent = s.title;
      head.querySelector('a').href = s.url;
      head.querySelector('.irs-hot__close').addEventListener('click', closeAll);

      var sizes = document.createElement('div');
      sizes.className = 'irs-hot__row irs-hot__sizes';

      var buy = document.createElement('div');
      buy.className = 'irs-hot__buy';
      var price = document.createElement('div');
      price.className = 'irs-hot__price';
      price.innerHTML = s.priceText;
      var atc = document.createElement('button');
      atc.className = 'irs-hot__atc';
      atc.type = 'submit';
      buy.appendChild(price);
      buy.appendChild(atc);

      var vid = document.createElement('input');
      vid.type = 'hidden'; vid.name = 'id';
      var qty = document.createElement('input');
      qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1';

      function sync() {
        Array.prototype.forEach.call(sizes.children, function (b, k) {
          b.setAttribute('aria-pressed', k === vIdx ? 'true' : 'false');
        });
        var v = s.variants[vIdx];
        if (v) vid.value = v.id;
        atc.disabled = !(v && v.available);
        atc.textContent = atc.disabled ? OOS : ATC;
      }

      s.variants.forEach(function (v, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = v.title;
        if (!v.available) b.disabled = true;
        b.addEventListener('click', function () { vIdx = k; sync(); });
        sizes.appendChild(b);
      });

      form.appendChild(vid);
      form.appendChild(qty);
      form.appendChild(head);
      form.appendChild(sizes);
      form.appendChild(buy);
      card.appendChild(form);
      media.appendChild(card);
      sync();

      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = card.classList.contains('is-open');
        closeAll();
        if (wasOpen) return;
        card.classList.add('is-open');
        dot.classList.add('is-open');
        dot.setAttribute('aria-expanded', 'true');
        place(card, s.x, s.y);
        open = { card: card, x: s.x, y: s.y };
      });
      card.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    root.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    window.addEventListener('resize', function () {
      if (open) place(open.card, open.x, open.y);
    });
  }

  function boot() { document.querySelectorAll('.irs-hot').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
